"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PortalCompatContextProvider: function() {
        return _PortalCompatContext.PortalCompatContextProvider;
    },
    usePortalCompat: function() {
        return _PortalCompatContext.usePortalCompat;
    }
});
var _PortalCompatContext = require("./PortalCompatContext");
